import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const PrimaryContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));
